<template>
    <sa-page-layout :btnConfigurazioniVisible="true" :btnNewVisible="false" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :linkback="linkback" :showModalLoading="showModalLoading" :linkConfigurazioni="linkConfigurazioni">
        <template slot="toolbar">
            <b-button size="sm" variant="success btn-toolbar sa-margin-right float-sm-right" @click="onClickNuovo">
                <b-icon icon="plus"></b-icon>
                Nuovo
            </b-button>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Codice</label>
                        <b-form-input v-model="filtroConfigurazioneAttivitaResidenziale.codiceAttivita" type="search" id="codice" placeholder="Inserire nome..."></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Nome</label>
                        <b-form-input v-model="filtroConfigurazioneAttivitaResidenziale.nomeAttivita" type="search" id="codice" placeholder="Inserire nome..."></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Area</label>
                        <b-form-select id="inline-form-custom-select-pref" v-model="filtroConfigurazioneAttivitaResidenziale.idArea" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="id" text-field="nome" :options="areaOptions"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Diario</label>
                        <b-form-select id="inline-form-custom-select-pref" v-model="filtroConfigurazioneAttivitaResidenziale.idDiario" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="id" text-field="nome" :options="diarioOptions"></b-form-select>
                    </b-col>
                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <rsa-configurazione-attivita-list-component ref="RsaConfigurazioneAttivitaListComponent" @afterLoadData="onAfterLoadData"></rsa-configurazione-attivita-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaConfigurazioneAttivitaListComponent from "../components/RsaConfigurazioneAttivitaListComponent.vue";
export default {
    components: { SaPageLayout, RsaConfigurazioneAttivitaListComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            filtroConfigurazioneAttivitaResidenziale: { nomeAttivita: null, idDiario: null, idArea: null, codiceAttivita: null },
            btnNewVisible: true,
            btnBackVisible: true,
            btnConfigurazioniVisible: true,
            linkback: "/home",
            pathResource: "/rsaattivita",
            pathResourceAree: "/rsaaree",
            pathResourceDiari: "/rsadiari",
            linkConfigurazioni: "/configurazioni",
            linkedit: "/rsaconfigurazioneattivita",
            showModalLoading: false,
            listKey: 0,
            diarioOptions: [],
            areaOptions: [],
        };
    },
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroConfigurazioneAttivitaResidenziale"]) {
            me.filtroConfigurazioneAttivitaResidenziale = JSON.parse(sessionStorage["filtroConfigurazioneAttivitaResidenziale"]);
        }
        me.loadData();
        me.loadAree();
        me.loadDiari();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.$refs.RsaConfigurazioneAttivitaListComponent.init("RESIDENZIALE");
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onReset() {
            let me = this;
            me.filtroConfigurazioneAttivitaResidenziale = { nomeAttivita: null, idDiario: null, idArea: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroConfigurazioneAttivitaResidenziale"] = JSON.stringify(me.filtroConfigurazioneAttivitaResidenziale);
            me.loadData();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroConfigurazioneAttivitaResidenziale"] = JSON.stringify(me.filtroConfigurazioneAttivitaResidenziale);
            me.loadData();
        },
        loadAree() {
            let me = this;
            me.loadDataResources(me.pathResourceAree, {}, me.resultResponseAree, me.resultErrorAree);
        },
        resultResponseAree(response) {
            let me = this;
            me.areaOptions = response.data.data.list;
            me.areaOptions.unshift({ value: null, nome: "- Seleziona Valore -" });
        },
        resultErrorAree(error) {
            console.log(error.response.messaggio);
            let messaggio = error.response.messaggio ? error.response.messaggio : "Errore caricamento Aree";
            this.$bvToast.toast(messaggio, {
                title: this.titleModal,
                variant: "danger",
                autoHideDelay: 1000,
            });
        },
        loadDiari() {
            let me = this;
            let presidio = { idPresidio: null };
            let idPresidio = null;
            if (localStorage.getItem("presidio")) {
                presidio = localStorage.getItem("presidio") == "null" ? null : JSON.parse(localStorage.getItem("presidio"));
                idPresidio = presidio ? presidio.idPresidio : null;
            }
            if (idPresidio) {
                me.loadDataResources(me.pathResourceDiari, { idPresidio: idPresidio }, me.resultResponseDiari, me.resultErrorDiari);
            } else {
                this.$bvToast.toast("Selezionare Presidio", {
                    title: "Attenzione",
                    variant: "danger",
                    solid: true,
                });
                me.diarioOptions.unshift({
                    id: null,
                    nome: "- Nessun Diario Disponibile -",
                });
            }
        },
        resultResponseDiari(response) {
            let me = this;
            me.diarioOptions = response.data.data.list;
            me.diarioOptions.unshift({ value: null, nome: "- Seleziona Valore -" });
        },
        resultErrorDiari(error) {
            console.log(error.response.messaggio);
            let messaggio = error.response.messaggio ? error.response.messaggio : "Errore caricamento Diari";
            this.$bvToast.toast(messaggio, {
                title: this.titleModal,
                variant: "danger",
                autoHideDelay: 1000,
            });
        },
        onClickNuovo() {
            let me = this;
            me.$router.replace(me.linkedit + "/edit/-1?tipologia=RESIDENZIALE").catch((err) => {
                err;
                console.log(err);
            });
        },
    },
};
</script>

<style></style>
